import { render, staticRenderFns } from "./gatewayinfo.vue?vue&type=template&id=e8a21736&"
import script from "./gatewayinfo.vue?vue&type=script&lang=js&"
export * from "./gatewayinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports